/* =========================
   CONFIG
========================= */
const requireEmail = true; // set true to require email before showing results
const GATE_KEY = "bfc__result_unlocked";

/* =========================
   ELEMENTS
========================= */
// Hidden inputs controlled by pill toggles
const genderSelect = document.getElementById("bfc__gender");
const unitSelect   = document.getElementById("bfc__units");

// Form pieces
const hipContainer = document.getElementById("bfc__hip-container");
const resultEl     = document.getElementById("bfc__result");

// Height (split inputs + containers)
const heightInContainer = document.getElementById("bfc__height-in-container");
const heightCmContainer = document.getElementById("bfc__height-cm-container");
const heightFeetInput   = document.getElementById("bfc__heightFeet");
const heightInchesInput = document.getElementById("bfc__heightInches");
const heightCmInput     = document.getElementById("bfc__heightCm");

// Scale + marker
const scaleEl      = document.getElementById("bfc__scale");
const markerEl     = document.getElementById("bfc__marker");
const markerLabel  = document.getElementById("bfc__markerLabel");

// Buttons
const downloadBtn  = document.getElementById("bfc__downloadBtn");
const recalcBtn    = document.getElementById("bfc__recalcBtn");

// Modal
const modal        = document.getElementById("bfc__emailModal");

// View containers
const panelEl         = document.querySelector(".bfc__panel");
const resultsWrapper  = document.querySelector(".bfc__results-wrapper");

// Height label unit span
const heightUnitSpan  = document.getElementById("bfc__height-unit");

let lastBodyFat = null, lastGender = null;
let currentUnit = unitSelect.value || "in"; // track previous unit for conversions

/* =========================
   TOGGLE GROUPS (UNIT / GENDER)
========================= */
function setupToggleGroup(groupId, hiddenInputId) {
  const group = document.getElementById(groupId);
  const hidden = document.getElementById(hiddenInputId);
  const buttons = Array.from(group.querySelectorAll('.bfc__toggle'));

  function setActive(val) {
    hidden.value = val;
    buttons.forEach(btn => {
      const active = btn.dataset.value === val;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    hidden.dispatchEvent(new Event('change', { bubbles: true }));
  }

  buttons.forEach(btn => btn.addEventListener('click', () => setActive(btn.dataset.value)));
  setActive(hidden.value); // initialize
}
setupToggleGroup('bfc__unitsToggle','bfc__units');
setupToggleGroup('bfc__genderToggle','bfc__gender');

/* =========================
   HEIGHT CONVERSIONS
========================= */
function feetInchesToInches(feet, inches){
  const f = Number.parseInt(feet, 10) || 0;
  const i = Number.parseInt(inches, 10) || 0;
  return f * 12 + i;
}
function inchesToFeetInches(totalInches){
  const ti = Math.max(0, Math.round(Number(totalInches) || 0));
  return { feet: Math.floor(ti / 12), inches: ti % 12 };
}
function cmToFeetInches(cm){
  const inches = (Number(cm) || 0) / 2.54;
  return inchesToFeetInches(inches);
}
function feetInchesToCm(feet, inches){
  return feetInchesToInches(feet, inches) * 2.54;
}

/* Show/hide height UI based on unit and convert existing value */
function syncHeightUIForUnit(newUnit, prevUnit){
  if (!heightInContainer || !heightCmContainer) return;

  if (newUnit === "in"){
    // Convert cm -> ft+in if there is a value
    if (prevUnit === "cm" && heightCmInput && heightCmInput.value){
      const { feet, inches } = cmToFeetInches(heightCmInput.value);
      if (heightFeetInput)   heightFeetInput.value   = feet;
      if (heightInchesInput) heightInchesInput.value = inches;
    }
    heightInContainer.style.display = "flex";
    heightCmContainer.style.display = "none";
    const err = document.getElementById("bfc__heightCm-error");
    if (err) err.textContent = "";
  } else {
    // Convert ft+in -> cm if there are values
    if (prevUnit === "in" && (heightFeetInput?.value || heightInchesInput?.value)){
      const cm = feetInchesToCm(heightFeetInput?.value, heightInchesInput?.value);
      if (heightCmInput) heightCmInput.value = cm ? cm.toFixed(2) : "";
    }
    heightInContainer.style.display = "none";
    heightCmContainer.style.display  = "flex";
    const errF = document.getElementById("bfc__heightFeet-error");
    const errI = document.getElementById("bfc__heightInches-error");
    if (errF) errF.textContent = "";
    if (errI) errI.textContent = "";
  }
}

/* =========================
   UNIT LABEL UPDATES
========================= */
function updateUnitLabels(unit){
  const labels = {
    waist: document.getElementById("bfc__waist-unit"),
    hip:   document.getElementById("bfc__hip-unit"),
    neck:  document.getElementById("bfc__neck-unit"),
    height: heightUnitSpan
  };
  const text = unit === "cm" ? "cm" : "inches";
  if (labels.waist) labels.waist.textContent = text;
  if (labels.hip)   labels.hip.textContent   = text;
  if (labels.neck)  labels.neck.textContent  = text;
  if (labels.height) labels.height.textContent = (unit === "cm") ? "(cm)" : "(ft + in)";
}

/* =========================
   UNIT + GENDER change logic
========================= */
genderSelect.addEventListener("change", () => {
  hipContainer.style.display = genderSelect.value === "female" ? "grid" : "none";
  if (genderSelect.value !== "female") {
    const hip = document.getElementById("bfc__hip");
    const hipErr = document.getElementById("bfc__hip-error");
    hip?.classList.remove("error");
    if (hipErr) hipErr.textContent = "";
  }
});

unitSelect.addEventListener("change", () => {
  const prev = currentUnit;
  const newU = unitSelect.value;

  // Height UI + conversion
  syncHeightUIForUnit(newU, prev);

  // Convert circumference fields currently filled
  const toCm  = newU === "cm";
  const factor = toCm ? 2.54 : 1 / 2.54;
  ["bfc__neck","bfc__waist","bfc__hip"].forEach(id => convertField(id, factor));

  currentUnit = newU;
  updateUnitLabels(newU);
});

function convertField(id, factor){
  const input = document.getElementById(id);
  if (input && input.value) input.value = (parseFloat(input.value) * factor).toFixed(2);
}

/* Initialize on load */
syncHeightUIForUnit(currentUnit, currentUnit);
updateUnitLabels(currentUnit);

/* =========================
   VALIDATION
========================= */
function setError(id, message){
  const input = document.getElementById(id);
  const error = document.getElementById(id + "-error");
  if (input) input.classList.add("error");
  if (error) error.textContent = message;
  return false;
}
function clearError(id){
  const input = document.getElementById(id);
  const error = document.getElementById(id + "-error");
  if (input) input.classList.remove("error");
  if (error) error.textContent = "";
}
function validateField(id, message){
  const input = document.getElementById(id);
  const error = document.getElementById(id+"-error");
  if (!input || input.offsetParent === null) return true;
  const val = parseFloat(input.value);
  if (!input.value || isNaN(val) || val <= 0){
    input.classList.add("error"); if (error) error.textContent = message; return false;
  }
  input.classList.remove("error"); if (error) error.textContent = ""; return true;
}
function validateHeight(){
  if (unitSelect.value === "in"){
    const fVal = heightFeetInput ? heightFeetInput.value : "";
    const iVal = heightInchesInput ? heightInchesInput.value : "";
    const f = Number.parseInt(fVal, 10);
    const i = Number.parseInt(iVal, 10);

    clearError("bfc__heightFeet");
    clearError("bfc__heightInches");

    if (fVal === "" || isNaN(f) || f <= 0) return setError("bfc__heightFeet", "Enter feet.");
    if (iVal === "" || isNaN(i) || i < 0) return setError("bfc__heightInches", "Enter inches (0–11).");
    if (i > 11) return setError("bfc__heightInches", "Inches must be 0–11.");
    if (f < 3 || f > 8) return setError("bfc__heightFeet", "Feet should be 3–8.");
    return true;
  } else {
    return validateField("bfc__heightCm", "Please enter your height in cm.");
  }
}
function getValidationMessage(id){
  return ({
    "bfc__neck":"Please enter your neck circumference.",
    "bfc__waist":"Enter your waist circumference.",
    "bfc__hip":"Please enter your hip circumference."
  })[id] || "This field is required.";
}
["bfc__neck","bfc__waist","bfc__hip"].forEach(id=>{
  document.getElementById(id)?.addEventListener("blur",()=>validateField(id,getValidationMessage(id)));
});
heightFeetInput?.addEventListener("blur", validateHeight);
heightInchesInput?.addEventListener("blur", validateHeight);
heightCmInput?.addEventListener("blur", validateHeight);

/* =========================
   CATEGORY + SCALE
========================= */
function getFatCategory(gender, bodyFat){
  if (gender === "male"){
    if (bodyFat <= 5)  return "Essential";
    if (bodyFat <= 13) return "Athletic";
    if (bodyFat <= 17) return "Fit";
    if (bodyFat <= 24) return "Average";
    return "Obese";
  } else {
    if (bodyFat <= 13) return "Essential";
    if (bodyFat <= 20) return "Athletic";
    if (bodyFat <= 24) return "Fit";
    if (bodyFat <= 31) return "Average";
    return "Obese";
  }
}
function getScaleMax(gender){ return gender === "male" ? 45 : 55; }
function updateMarker(bodyFat, gender){
  const max = getScaleMax(gender);
  const clamped = Math.max(0, Math.min(max, Number(bodyFat)));
  const leftPct = (clamped / max) * 100;
  markerEl.style.left = leftPct + "%";
  markerLabel.textContent = getFatCategory(gender, clamped).toUpperCase();
}

/* =========================
   SHOW / CLEAR RESULT
========================= */
function showResult(bodyFat, gender){
  const fat = +Number(bodyFat).toFixed(2);
  document.querySelector(".bfc__results-header").style.display = "block";
  document.getElementById("bfc__result-caption").style.display = "block";
  resultEl.textContent = `${fat}%`;
  updateMarker(fat, gender);
  scaleEl.style.display = "block";
  downloadBtn.style.display = "inline-block"; downloadBtn.disabled = false;
  if (recalcBtn) recalcBtn.style.display = "inline-block";
  if (window.innerWidth >= 900) panelEl?.classList.add("is-hidden");
  resultsWrapper?.classList.remove("is-hidden");
}
function clearResult(){
  resultEl.textContent = "";
  scaleEl.style.display = "none";
  document.querySelector(".bfc__results-header").style.display = "none";
  document.getElementById("bfc__result-caption").style.display = "none";
  downloadBtn.style.display = "none"; downloadBtn.disabled = true;
  if (recalcBtn) recalcBtn.style.display = "none";
  resultsWrapper?.classList.add("is-hidden");
  if (window.innerWidth >= 900) panelEl?.classList.remove("is-hidden");
}

/* =========================
   RECALCULATE
========================= */
function handleRecalculate(){
  handleReset();
  panelEl?.scrollIntoView({ behavior: "smooth", block: "start" });
}

/* =========================
   MODAL (EMAIL GATE)
========================= */
function openModal(){ modal.style.display="flex"; document.body.style.overflow="hidden"; }
function closeModal(){ modal.style.display="none"; document.body.style.overflow=""; }
window.addEventListener("klaviyoForms", function(e){
  if (e?.detail?.type === "submit" && e.detail.formId === "TUauuA"){
    localStorage.setItem(GATE_KEY,"1");
    closeModal();
    if (lastBodyFat != null && lastGender) showResult(lastBodyFat, lastGender);
  }
});

/* =========================
   CALCULATION
========================= */
function handleCalculate(){
  const gender = genderSelect.value;
  const unit   = unitSelect.value;
  const valid = [
    validateHeight(),
    validateField("bfc__neck",getValidationMessage("bfc__neck")),
    validateField("bfc__waist",getValidationMessage("bfc__waist")),
    gender === "female" ? validateField("bfc__hip",getValidationMessage("bfc__hip")) : true
  ].every(Boolean);
  if (!valid){ clearResult(); return; }

  // Height in cm (formula expects cm)
  let heightCm = 0;
  if (unit === "in") heightCm = feetInchesToCm(heightFeetInput?.value, heightInchesInput?.value);
  else heightCm = parseFloat(heightCmInput?.value || "0");

  // Other measures in cm
  let neck  = +document.getElementById("bfc__neck").value;
  let waist = +document.getElementById("bfc__waist").value;
  let hip   = +document.getElementById("bfc__hip").value;

  if (unit==="in"){
    neck  *= 2.54; waist *= 2.54; if (gender === "female") hip *= 2.54;
  }

  // Prevent invalid log inputs for Navy method
  if ((gender==="male"   && (waist - neck <= 0 || heightCm <= 0)) ||
      (gender==="female" && (waist + hip - neck <= 0 || heightCm <= 0))){
    resultEl.textContent = "Invalid measurement combination. Make sure waist is larger than neck and all values are positive.";
    scaleEl.style.display="none";
    downloadBtn.style.display = "none"; downloadBtn.disabled = true;
    if (recalcBtn) recalcBtn.style.display = "none";
    return;
  }

  // U.S. Navy body fat formula
  let bodyFat = gender === "male"
    ? 495/(1.0324 - 0.19077*Math.log10(waist - neck) + 0.15456*Math.log10(heightCm)) - 450
    : 495/(1.29579 - 0.35004*Math.log10(waist + hip - neck) + 0.22100*Math.log10(heightCm)) - 450;

  if (isNaN(bodyFat) || bodyFat < 0 || bodyFat > 75){
    resultEl.textContent = "Something seems off with the entered measurements. Please double-check your values.";
    scaleEl.style.display="none";
    downloadBtn.style.display = "none"; downloadBtn.disabled = true;
    if (recalcBtn) recalcBtn.style.display = "none";
    return;
  }

  lastBodyFat = +bodyFat.toFixed(2);
  lastGender  = gender;

  if (requireEmail){
    const unlocked = localStorage.getItem(GATE_KEY) === "1";
    if (unlocked) showResult(lastBodyFat, lastGender);
    else openModal();
  } else {
    showResult(lastBodyFat, lastGender);
  }
}

/* =========================
   RESET
========================= */
function handleReset(){
  ["bfc__neck","bfc__waist","bfc__hip","bfc__heightFeet","bfc__heightInches","bfc__heightCm"].forEach(id=>{
    const el=document.getElementById(id);
    if(el){ el.value=""; el.classList.remove("error"); const er=document.getElementById(id+"-error"); if(er) er.textContent=""; }
  });

  // Defaults: inches & female
  document.querySelector('#bfc__unitsToggle .bfc__toggle.is-active')?.classList.remove('is-active');
  document.querySelector('#bfc__unitsToggle .bfc__toggle[data-value="in"]').classList.add('is-active');
  unitSelect.value = "in"; currentUnit = "in";
  unitSelect.dispatchEvent(new Event('change',{bubbles:true}));

  document.querySelector('#bfc__genderToggle .bfc__toggle.is-active')?.classList.remove('is-active');
  document.querySelector('#bfc__genderToggle .bfc__toggle[data-value="female"]').classList.add('is-active');
  genderSelect.value = "female";
  genderSelect.dispatchEvent(new Event('change',{bubbles:true}));

  resultsWrapper?.classList.add("is-hidden");
  if (window.innerWidth >= 900) panelEl?.classList.remove("is-hidden");

  downloadBtn.style.display = "none"; downloadBtn.disabled = true;
  if (recalcBtn) recalcBtn.style.display = "none";
}

/* =========================
   PDF (jsPDF)
========================= */
function pdfDrawScale(doc, x, y, w, h, fat, gender) {
  const max = getScaleMax(gender);
  const clamped = Math.max(0, Math.min(max, Number(fat)));
  const posX = x + (clamped / max) * w;

  const segments = [
    { pct: 0.20, color: [158,197,255] },
    { pct: 0.20, color: [191,232,191] },
    { pct: 0.20, color: [242,229,164] },
    { pct: 0.20, color: [247,199,160] },
    { pct: 0.20, color: [239,154,154] }
  ];

  let cursor = x;
  segments.forEach(s => {
    const segW = w * s.pct;
    doc.setFillColor(...s.color);
    doc.rect(cursor, y, segW, h, "F");
    cursor += segW;
  });

  doc.setDrawColor(200);
  if (doc.roundedRect) doc.roundedRect(x, y, w, h, 7, 7, "S");
  else doc.rect(x, y, w, h, "S");

  const triH = 10, triW = 12;
  const tipX = posX, tipY = y - 6;
  doc.setFillColor(51,51,51);
  if (doc.triangle) doc.triangle(tipX, tipY, tipX - triW/2, tipY - triH, tipX + triW/2, tipY - triH, "F");

  const category = getFatCategory(gender, clamped).toUpperCase();
  doc.setFont("helvetica","bold"); doc.setFontSize(10);
  const labelW = doc.getTextWidth(category);
  doc.text(category, Math.max(x, Math.min(x + w - labelW, tipX - labelW / 2)), tipY - triH - 6);

  doc.setFont("helvetica","normal"); doc.setFontSize(9); doc.setTextColor(90);
  doc.text("0%", x, y + h + 14);
  const maxLabel = `${max}%`; const tw = doc.getTextWidth(maxLabel);
  doc.text(maxLabel, x + w - tw, y + h + 14);
  doc.setTextColor(0);
}
function downloadPDF(){
  if (lastBodyFat == null || !lastGender) return;

  const { jsPDF } = window.jspdf;
  const doc = new jsPDF({ unit: "pt", format: "a4" });

  const ml = 56;
  const pageH = doc.internal.pageSize.getHeight();
  const pageW = doc.internal.pageSize.getWidth();
  const contentW = pageW - ml * 2;

  const gender = lastGender;
  const fat = lastBodyFat;

  const units = unitSelect.value;
  let heightDisplay = "-";
  if (units === "in") {
    const f = heightFeetInput?.value || 0;
    const i = heightInchesInput?.value || 0;
    heightDisplay = `${f} ft ${i} in`;
  } else {
    heightDisplay = `${heightCmInput?.value || "-"} cm`;
  }
  const neck   = document.getElementById("bfc__neck").value || "-";
  const waist  = document.getElementById("bfc__waist").value || "-";
  const hip    = document.getElementById("bfc__hip")?.value || "-";
  const unitLabel = (units === "cm") ? "cm" : "inches";

  doc.setFont("helvetica","bold"); doc.setFontSize(22);
  doc.text("Your Results", ml, 74);

  doc.setFont("helvetica","normal"); doc.setFontSize(11);
  doc.text("Below results are based on the U.S. Navy Body Fat Formula.", ml, 96);

  doc.setFont("helvetica","bold"); doc.setFontSize(38);
  doc.text(`${fat}%`, ml, 148);

  const barX = ml, barY = 210, barW = Math.min(440, contentW), barH = 16;
  pdfDrawScale(doc, barX, barY, barW, barH, fat, gender);

  const yAfterScale = barY + barH + 40;

  doc.setFont("helvetica","bold"); doc.setFontSize(14);
  doc.text("Inputs", ml, yAfterScale);

  doc.setFont("helvetica","normal"); doc.setFontSize(12);
  let y = yAfterScale + 24;

  const rows = [
    `Gender: ${gender}`,
    `Units: ${units === "cm" ? "Centimeters" : "Inches"}`,
    `Height: ${heightDisplay}`,
    `Neck: ${neck} ${unitLabel}`,
    `Waist: ${waist} ${unitLabel}`
  ];
  if (gender === "female") rows.push(`Hip: ${hip} ${unitLabel}`);

  rows.forEach(line => { doc.text(line, ml, y); y += 18; });

  doc.setFontSize(10); doc.setTextColor(120);
  doc.text(`Generated on ${new Date().toLocaleString()}`, ml, pageH - 40);

  doc.save("body-fat-result.pdf");
}

/* =========================
   EXPORT
========================= */
window.handleCalculate   = handleCalculate;
window.handleReset       = handleReset;
window.handleRecalculate = handleRecalculate;
window.closeModal        = closeModal;
window.downloadPDF       = downloadPDF;
